import { addNewRelicPageAction } from '@ddc/new-relic';

/**
 *
 * @param {Object} window The global window object which needs should have DDC.dataLayer.[page|vehicles] and DDC.APILoader
 * @param {Integer} timeout A timeout indicating the maximum time in ms to wait for this function to resolve. Defaults to 5000 (5 seconds)
 * @returns A promise which resolves after the `timeout` or when window.DDC.dataLayer.vehicles length is over 0.
 * If the promise resolves with a 'value' of 'timeout' the vehicle data did not come in time.
 */
const vehicleDataUpdated = (
	{
		DDC: {
			dataLayer: { page = {}, vehicles = [] } = {},
			dataLayer = {},
			APILoader = {}
		} = {}
	} = {},
	timeout = 5000
) => {
	const vehiclesInfo = {
		isVlp: page?.pageInfo?.isVlp,
		vehiclesLength: vehicles?.length
	};

	let promise;
	if (vehiclesInfo.isVlp && !vehiclesInfo.vehiclesLength) {
		promise = new Promise((resolve) => {
			let settled = false;
			let vehicleInterval;
			let safeTimeout;

			const settle = (value) => {
				if (settled) return;
				settled = true;
				clearInterval(vehicleInterval);
				clearTimeout(safeTimeout);
				if (value === 'timeout') {
					addNewRelicPageAction('wsTaggingVehicleData', {
						wsTaggingError: 'vehicleDataDidntUpdate'
					});
				}
				resolve(value);
			};

			// Poll for vehicle data in dataLayer
			vehicleInterval = setInterval(() => {
				if (dataLayer?.vehicles?.length) {
					settle('datalayer');
				}
			}, 10);

			// Listen for vehicle-data-updated-v1 via API
			(async () => {
				try {
					const API = await APILoader?.create('ws-tagging');
					API.subscribe('vehicle-data-updated-v1', () => {
						settle('api');
					});
				} catch (e) {
					// APILoader not available, ignore
				}
			})();

			// Safe timeout fallback
			safeTimeout = setTimeout(() => {
				settle('timeout');
			}, timeout);
		});
	} else {
		promise = Promise.resolve(vehiclesInfo);
	}

	return promise;
};

export default vehicleDataUpdated;
